import {Menu, PopoverOrigin} from "@mui/material";
import Button from "@mui/material/Button";
import {ColDef, GridApi} from "ag-grid-community";
import {tableControlStyle} from "../TableControls";
import {Fragment, useRef, useState} from "react";
import React from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ColDisplayMenuItem from "./ColDisplayMenuItem";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import Divider from "@mui/material/Divider";
import MenuItem from "@mui/material/MenuItem";
import { saveGridColumnLayout } from "../columnLayoutPersistence";


const menuAnchorOrigin: PopoverOrigin = {
  vertical: "bottom",
  horizontal: "left",
};

const ColFreezeMenu = ({table, layoutScope}) => {
  if(!table.current) {
    return <div>
    </div>
  }
  let columnApi = table.current.columnApi;
  const columnDefs = columnApi.columnModel.columnDefs as ColDef[]
  const [menuOpened, setMenuOpened] = useState(false);
  const [allVisible, setAllVisibleState] = useState(true);
  const [updateKey, setUpdateKey] = useState(0); // Force re-render of menu items
  const colFreezeBtn = useRef();

  function toggleAllVisible() {
    const allCurrentlyVisible = columnApi
      .getColumnState()
      .every((columnState) => !columnState.hide);
    const columnIds = columnDefs
      .map((colDef) => colDef.colId || colDef.field)
      .filter(Boolean);
    const nextVisibleState = !allCurrentlyVisible;

    columnApi.setColumnsVisible(columnIds, nextVisibleState);
    saveGridColumnLayout(columnApi, layoutScope);
    setAllVisibleState(nextVisibleState);
    setUpdateKey(prev => prev + 1); // Force re-render
  }

  function onColUpdate() {
    const allVisible = columnApi
      .getColumnState()
      .every((columnState) => !columnState.hide);
    setAllVisibleState(allVisible)
  }

  let colFreezeItems = columnDefs.map((colDef: ColDef, index) => (
    <ColDisplayMenuItem override={allVisible} onUpdate={onColUpdate} key={`${colDef.field}-${index}-${updateKey}`} colDef={colDef}
                        columnApi={columnApi} layoutScope={layoutScope}/>
  ));
  let colDisplayItems = <Menu
    open={menuOpened}
    onClose={() => setMenuOpened(false)}
    anchorEl={colFreezeBtn.current}
    anchorOrigin={menuAnchorOrigin}
    container={document.getElementById("fullScreen-wrap")}

  >
    <MenuItem onClick={() => {
      toggleAllVisible()
    }}>
      <input
        type="checkbox"
        checked={allVisible}
        onChange={() => {
        }}
      >
      </input>
      All
    </MenuItem>
    <Divider orientation="horizontal"/>
    {colFreezeItems}
  </Menu>;
  return <Fragment>
    <Button startIcon={<VisibilityOutlinedIcon/>} endIcon={<ArrowDropDownIcon/>} ref={colFreezeBtn}
            sx={tableControlStyle} onClick={() => setMenuOpened(!menuOpened)}>
      Columns
    </Button>
    {colDisplayItems}
  </Fragment>
};

export default ColFreezeMenu;